export default {
    success: 'Your comment was successfully updated',
    action: 'Edit'
}
